<template>
  <v-container class="visao-analitica mb-3 px-6">
    <v-row class="px-0 py-5">
      <v-col>
        <h1>Visão Analítica</h1>
        <p>Visão Gerencial das solicitações de autorização.</p>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="4"  class="px-3 pr-5 py-0">
            <label>Prestador</label>
            <v-autocomplete
              v-model="formData.prestador_id"
              :items="prestadoresFilter"
              item-value="id"
              item-text="prest_nome"
              label="Selecione"
              multiple
              chips
              outlined
              flat
              solo
              dense
              filled
              :disabled="prestadoresFilter.length==1"
            >
          <template v-slot:item="data">
            <v-list-item @click="toggleAutocomplete(data.item, 'prestador_id');" :class="formData.prestador_id.includes(data.item.id)? 'primary--text v-list-item--active': ''">
              <v-list-item-content>
                <v-list-item-title>{{data.item.prest_nome}}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
        </template>
          <template v-slot:selection="data">
            <v-chip v-if="data.index < 2" small label class="ma-1" :style="formData.prestador_id.length>1? 'max-width:28%':'max-width:90%'">{{
              data.item.prest_nome
            }}</v-chip>
            <span v-if="data.index == 2" class="ml-2 grey--text caption">
              (+{{
                formData.prestador_id.length == 3
                  ? formData.prestador_id.length - 2 + " outro"
                  : formData.prestador_id.length - 2 + " outros"
              }})
            </span>
          </template>
        </v-autocomplete>
      </v-col>
      </v-row>
    <v-row>
      <v-col class="px-3 py-5" cols="12" sm="12" md="12">
        <v-card outlined>
          <v-col class="pa-5">
            <h2 class="authorizer-title">Gráfico de performance por operadora</h2>
          </v-col>
        
          <v-col class="pb-0">
            <FilterBar
              :gerarGrafico="formData => getGraficoPerformance(formData)"
              :operadoras="operadoras"
              :list="listBar"
            />
          </v-col>
          <v-col class="pt-0">
            <ChartBar 
              :list="listBar"
              :listOperadora="listOperadora"
            />
          </v-col>
        </v-card>
      </v-col>
      <v-col class="px-3 py-5" cols="12" sm="12" md="12">
        <v-card outlined>
          <v-col class="px-5 pt-5 pb-0">
            <h2 class="authorizer-title">Gráfico comparativo de solicitações por período</h2>
            <p>Compare as quantidade de solicitações de autorizações enviadas a uma operadora em intervalos de tempo (mensal ou semanal).</p>
          </v-col>
          <v-col class="py-0">
            <FilterLine
              :filterChart="formData => getGraficoComparativo(formData)"
              :operadoras="operadoras"
              :currentLine="listLine"
            />
          </v-col>
          <v-col class="py-0">
            <ChartLine 
              :dataChart="listLine" 
            />
          </v-col>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapActions } from "vuex"
import ChartBar from "../charts/ChartBar"
import FilterBar from "../charts/FilterBar"
import ChartLine from "../charts/ChartLine"
import FilterLine from "../charts/FilterLine"
export default {
  components: {
    ChartBar,
    FilterBar,
    ChartLine,
    FilterLine,
  },
  data() {
    return {
      selectedItem: {},
      listLine: {},
      listBar: {
        data_referencia: null,
        dados:[],
      },
      operadoras:[],
      prestadores: [],
      prestadoresFilter:[],
      formData:{
        prestador_id: []
        }
    };
  },
  computed: {
    ...mapState({
      grupoEconomico: (state) => state.permissions.grupoEconomico,
      // prestadores: (state) => state.userData.prestadores,
      modules: (state) => state.userData.modules,
      listOperadora: (state) => state.permissions.operadoras,
    }),
  },
  watch:{
    grupoEconomico:{
      deep: true,
      handler() {
        this.prestadoresFilter = this.$store.getters["permissions/getPrestadoresByGeco"]()
        if (this.prestadoresFilter.length==1) {
          this.formData.prestador_id = [this.prestadoresFilter[0].id]
        } 
        else {
          this.formData.prestador_id = [];
        }
      }
    }
  },
  mounted() {
    this.prestadoresFilter = this.$store.getters["permissions/getPrestadoresByGeco"]()
    if (this.prestadoresFilter.length==1) {
          this.formData.prestador_id = [this.prestadoresFilter[0].id]
        } 
        else {
          this.formData.prestador_id = [];
        }
    let opts= {
      operadora_ans_id: null, periodo: "mes", data_referencia: null, data_referencia1: null,
       data_referencia2: null,
       operadoras:[]
       }
    this.getGraficoComparativo(opts)
    let opts2= {
       data_referencia: null,
       operadoras:[]
       }
    this.getGraficoPerformance(opts2) 
    let opts3 = {
      grupoEconomico: this.grupoEconomico,
      modulo_operadora: "autorizador",
    }
    this.getOperadoras(opts3).then(list=> {
      this.operadoras = list
      // this.operadoras.unshift({id: null, oper_nome: "Selecione"})
    })
  },
  methods: {
     ...mapActions("permissions", [
      "getOperadoras",
    ]),
    getGraficoComparativo(formData) {
      let  { prestador_id } = this.formData

      let obj = {
          query: [{ 
            Modulo: "Autorizador",
            Acao: "getgraficocomparativo",
            Payload: { grupo_economico: this.grupoEconomico, ...formData, prestador_id}
          }],
      }
      let nomeOperadora = this.listOperadora[formData.operadora_ans_id]
      this.$store.dispatch("request/doRequest", obj).then(response => {
        this.listLine = Object.assign(response, { operadora: nomeOperadora })
        if(!response || response.isAxiosError) {
          this.$store.commit("hideLoader")
          return
        }
      })
    },
    getGraficoPerformance(formData) {
      let  { prestador_id } = this.formData
      let obj = {
          query: [{ 
            Modulo: "Autorizador",
            Acao: "getgraficoperformance",
            Payload: {grupo_economico: this.grupoEconomico, ...formData, prestador_id}
          }],
      }
      this.$store.dispatch("request/doRequest", obj).then(response => {
        this.listBar = response
        if(!response || response.isAxiosError) {
          this.$store.commit("hideLoader")
          return
        }
      })
    },
    selectItem(item, action) {
      this.selectedItem = Object.assign({}, item);
      switch (action) {
        case "newDoc":
          this.showList = false;
          break;

        default:
          break;
      }
    },
    toggleAutocomplete(item, campo) {
      let index = this.formData[campo].indexOf(item.id)
      //  index > -1  está excluindo a operadora
      if (index > -1) {
        this.formData[campo].splice(index, 1)
      } else {
      //  index < 0  está adicionando a operadora
          this.formData[campo].push(item.id)
      }
        this.$nextTick()
        return
    },
    formatDateMonth(date) {
      if (!date) return null;
      const [year, month] = date.split("-");
      return `${month}/${year}`;
    },
    parseDateMonth(date) {
      if (!date) return null;
      const [month, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}`;
    },
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;
      const [day, month, year] = date.split("/");
      return `${year}-${month}-${day}`;
    },
  },
};
</script>

<style>
</style>